<template>
    <CContainer fluid>
      <h3>Administraci&oacute;n de Usuarios</h3>
      <CCard class="mt-4">
        <CCardBody class="p-3">
          <CRow>
            <CCol col="sm-8">
              <CInput 
                label="Buscar:"
                class="col-sm-9 d-inline-block"
                :value.sync="searchWord"
                @keyup.enter="getData(1, searchWord)">
                <template #prepend-content>
                  <a href="#" @click="getData(1)">
                    <i class="bi bi-arrow-clockwise"></i>
                  </a>
                </template>
                <template #append-content>
                  <a href="#" @click="getData(1, searchWord)">
                    <i class="bi bi-search"></i>
                  </a>
                </template>
              </CInput>
              <div class="d-inline-block mt-4 ml-2">
                <CButton 
                  color="success"
                  to="/administracion/ayudas/acerca/usuarios/agregar">
                  <i class="bi bi-plus-circle"></i>
                  <span class="align-middle ml-2">Agregar</span>
                </CButton>
              </div>
            </CCol>
            <CCol col="sm-4">
              <div class="d-inline-block valign-center mt-4">
                <CSpinner color="dark" size="sm" class="ml-3 d-inline-block" v-if="loadingGeneral"/>
                <h5 class="d-inline-block ml-3">{{ selectedUserName }}</h5>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol col="sm-8">
              <CDataTable
                hover
                responsive
                :items="users"
                :fields="fieldsUser"
                :items-per-page="itemsPerPage" 
                @row-clicked="(item, index, _columnName, e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  if (item.tipo_Usuario === 'C') {
                    getDataDependencies(item.id_UsuarioInternet, item.nombre_Usuario)
                  } else {
                    dependencies = []
                  }
                }">
                <template #usuario="{item}">
                  <td>
                    <h4>{{ item.nombre_Usuario }}</h4>
                    <div>
                      <CIcon name="cil-user"/>
                      {{ item.usuario }}
                    </div>
                    <div>
                      {{ item.tipo_Usuario == "C" ? "Cliente" : "Empleado" }}
                    </div>
                  </td>
                </template>
                <template #informacion="{item}">
                  <td>
                    <div>
                      <CIcon v-if="item.estado == 'A'" name="cil-smile" class="text-success mr-2" />
                      <CIcon v-if="item.estado == 'I'" name="cil-mood-very-bad" class="text-danger mr-2" />
                      <span v-if="item.estado == 'A'">Activo</span>
                      <span v-if="item.estado == 'I'">Inactivo</span>
                    </div>
                    <div>
                      <CIcon name="cil-calendar" class="mr-1" />
                      {{ moment(item.ultimo_Ingreso).format('DD/MM/YYYY') }}
                    </div>
                    <div>
                      <CIcon name="cil-history" class="mr-1" />
                      {{ moment(item.ultimo_Ingreso).format('HH:mm') }}
                    </div>
                  </td>
                </template>
                <template #action="{item}">
                  <td>
                    <div>
                      <a href="#" 
                        class="mr-2" 
                        @click="updateUser(item.id_UsuarioInternet)">
                        <i class="bi bi-pencil text-warning h4"></i>
                      </a>
                      <a href="#" 
                        class="mr-2"
                        @click="deleteUser(item.id_UsuarioInternet)">
                        <i class="bi bi-trash text-danger h4"></i>
                      </a>
                      <a href="#" v-if="item.tipo_Usuario === 'C'"
                        @click="(e) => openPanelAddUserDependency(e, item.id_UsuarioInternet, item.directorio)">
                        <i class="bi bi-bag-plus text-dark h4"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </CDataTable>
              <CPagination
                class="d-flex justify-content-center"
                size="sm"
                :activePage.sync="page"
                :pages="pageCount"
                @update:activePage="(value, a) => getData(value, searchWord)"
              />

              <CElementCover :opacity="0.75" v-show="loading">
                <div class="text-dark p-3 text-center">
                  <img src="@/assets/images/blocks-shuffle.svg" alt="Spinner" height="24" width="24" />
                  <h4 class="ml-2">Cargando...</h4>
                </div>
              </CElementCover>
            </CCol>
            <CCol col="sm-4">
              <CDataTable
                hover 
                pagination
                :items="dependencies"
                :fields="fieldsDependency"
                :items-per-page="itemsPerPage">
                <template #dependencia="{item}">
                  <td>
                    <h4>{{ item.dependencia }}</h4>
                    <div>
                      <strong>{{ item.codigo }}</strong>
                    </div>
                    <div>
                      {{ item.responsable }}
                    </div>
                  </td>
                </template>
                <template #action="{item}">
                  <td>
                    <a href="#" 
                      class="mb-2" 
                      @click="deleteUserDependency(item.id_DependenciaUsuario)">
                      <CIcon name="cil-trash" class="text-danger"/>
                    </a>
                  </td>
                </template>
              </CDataTable>

              <CElementCover v-show="loadingGeneral">
                <div class="text-dark p-3 text-center">
                  <img src="@/assets/images/blocks-shuffle.svg" alt="Spinner" height="24" width="24" />
                  <h4 class="ml-2">Cargando...</h4>
                </div>
              </CElementCover>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      <RightSideBar size="md" class="bg-s3grey" :show="showSidebarFormDependency">
        <CContainer>
          <CCard class="mt-3">
            <CCardHeader>
              <CCardTitle>
                <h4>Agregar Dependencia</h4>
              </CCardTitle>
            </CCardHeader>
            <CCardBody>
              <VerticalDynamicForm :fields="userDependenciesFields" />
            </CCardBody>
            <CCardFooter>
              <div class="d-flex justify-content-center">
                <CButton 
                  color="success"
                  @click="(e) => {
                    addUserDependency(e);
                  }">
                  <i class="bi bi-check-circle"></i>
                  <span class="align-middle ml-2">Guardar</span>
                </CButton>
                <CButton 
                  color="secondary"
                  class="ml-2"
                  @click="showSidebarFormDependency = false">
                  <i class="bi bi-x-circle"></i>
                  <span class="align-middle ml-2">Cancelar</span>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        </CContainer>
      </RightSideBar>
    </CContainer>
</template>

<script>
  import moment from "moment";
  import { dataGridUsuarios, crudUsuario } from "@/apis/security";
  import { dataGridDependenciasUsuario } from "@/apiDataGrids";
  import { dataListDependencias } from "@/apiDataList";
  import { crudDependenciaUsuario } from "@/apiCRUD";

  import RightSideBar from "../../components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "../../components/containers/VerticalDynamicForm.vue";

  const fieldsUser = [
    { key: 'usuario', _style:'text-align:center;' },
    { key: 'informacion', label: 'Información', _style:'text-align:center;' },
    { key: 'action', label: '', _style:'text-align:center;' }
  ]
  const fieldsDependency = [
    { key: "dependencia", _style: "text-align: center;" },
    { key: "action", label: "", _style: "text-align: center;" }
  ]

  export default {
    name: 'Users',
    data () {
      return {
        moment,
        loading: false,
        loadingGeneral: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        showSidebarFormDependency: null,
        users:[],
        fieldsUser,
        selectedIdUser: "",
        selectedUserName: "",
        dependencies: [],
        listDependencies: [],
        fieldsDependency,
        userDependenciesFields: [
          { 
            key: "idDependencia", 
            label: "Dependencia:", 
            value: "",
            type: "select",
            options: [],
            required: true,
            prepend_content: {
              name: "cil-library-add",
            }
          },
          {
            key: "estado",
            label: "Estado:",
            value: true,
            type: "switch",
            prepend_content: {
              name: "cil-check-circle"
            }
          },
          {
            key: "activeDateRestrictions", 
            label: "Activar Restriccion de Fechas:", 
            value: false,
            type: "switch",
            on_change: (value) => {
              if (value) {
                this.userDependenciesFields[3].value = "";
                this.userDependenciesFields[4].value = "";
                this.userDependenciesFields[3].required = true;
                this.userDependenciesFields[4].required = true;
                this.userDependenciesFields[3].disabled = false;
                this.userDependenciesFields[4].disabled = false;
              } else {
                this.userDependenciesFields[3].value = "";
                this.userDependenciesFields[4].value = "";
                this.userDependenciesFields[3].required = false;
                this.userDependenciesFields[4].required = false;
                this.userDependenciesFields[3].disabled = true;
                this.userDependenciesFields[4].disabled = true;
              }
            }
          },
          {
            key: "fechaInicio",
            label: "Fecha Inicio:",
            value: "",
            type: "date",
            disabled: true,
            prepend_content: {
              name: "cil-calendar",
            }
          },
          {
            key: "fechaFin",
            label: "Fecha Fin:",
            value: "",
            type: "date",
            disabled: true,
            prepend_content: {
              name: "cil-calendar",
            }
          }
        ]
      }
    },
    components: {
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      async getData(page, search) {
        this.loading = true

        try {
          const { count, results } =  await dataGridUsuarios(
            this,
            page,
            search,
            'todos',
            this.$store.state.user.data.id_Directorio
          )
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.users = results

          // clear data dependencies user
          this.selectedUserName = ''
          this.dependencies = []
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async updateUser(idUser) {
        console.log("Under construnction..." + idUser);
      },
      async deleteUser(idUser) {
        this.loading = true

        try {
          const { errorCode, errorMessage } = await crudUsuario(this, "delete", idUser)

          if (errorCode === 0) {
            this.getData(1)

            this.$store.commit("setAlert", {
              color: "success",
              message: "Se borro correctamente el registro.",
              show: 5
            })
          } else {
            this.$store.commit("setAlert", {
              color: "danger",
              message: errorMessage,
              show: 5
            })
          }
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar datos",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async openPanelAddUserDependency(e, idUser, idDirectory) {
        e.preventDefault();
        e.stopPropagation();

        const response = await dataListDependencias(this, idDirectory);

        this.userDependenciesFields[0].options = [
          {
            label: "Seleccionar",
            value: ""
          },
          ...response.map(item => {
            return {
              value: item.id_Dependencia,
              label: `${item.dependencia} - ${item.responsable}`
            }
          })
        ]
        
        this.selectedIdUser = idUser;
        this.showSidebarFormDependency = true;
      },
      async getDataDependencies(idUser, userName) {
        this.loadingGeneral = true;

        try {
          const results = await dataGridDependenciasUsuario(this, idUser);

          this.dependencies = results
          this.selectedUserName = userName
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos...",
            show: 5
          })
        } finally {
          this.loadingGeneral = false
        }
      },
      async addUserDependency(e) {
        e.preventDefault();
        e.stopPropagation();

        // Load dependencies options
        try {
          const dataRequest = {
            "usuario": this.selectedIdUser,
            "dependencia": this.userDependenciesFields[0].value,
            "estado": this.userDependenciesFields[1].value ? "A" : "I",
            "activar_RestriccionFechas": this.userDependenciesFields[2].value ? "V" : "F",
            "dia_InicialRestriccion": this.userDependenciesFields[3].value ? this.userDependenciesFields[3].value : null,
            "dia_FinalRestriccion": this.userDependenciesFields[4].value ? this.userDependenciesFields[4].value : null
          }

          console.log("dataRequest", dataRequest);
          

          const { errorCode, errorMessage } = await crudDependenciaUsuario(this, "create", null, dataRequest);

          console.log("errorCode", errorCode);
          console.log("errorMessage", errorMessage);
        } catch (error) {
          console.log(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al grabar la dependencia...",
            show: 5
          });
        } finally {
          this.showSidebarFormDependency = false;
        }

        // Reset fields for new dependency
        this.userDependenciesFields.forEach(field => {
          if (field.type === 'select') {
            field.value = '';
          } else if (field.type === 'switch') {
            field.value = false;
          } else {
            field.value = '';
          }
        });

      },
      async deleteUserDependency(idUserDependecy) {
        this.loadingGeneral = true;

        try {
          await crudDependenciaUsuario(this, "delete", idUserDependecy, null)

          this.getDataDependencies();
          this.selectedUserName = "";
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al borrar el registro...",
            show: 5
          })
        } finally {
          this.loadingGeneral = false
        }
      }
    },
    async mounted(){
      await this.getData(this.page)
    }
  }
</script>